import { Box, VStack, HStack, useColorModeValue } from "@chakra-ui/react";
import { Paragraph02, Paragraph04 } from "~/components/Texts";
import { CgCreditCard } from "react-icons/cg";
import tinycolor from "tinycolor2";

const PAYMENT_METHOD_MERCADOPAGO = "mercadopago";

export default function OrderDetailsPayment({ shop, order }) {
  if (order.payment.method === PAYMENT_METHOD_MERCADOPAGO)
    return (
      <HStack w="100%" px="4" py="2" align="flex-start" spacing="4">
        <Box
          mt="4"
          p="4"
          borderRadius="full"
          backgroundColor={shop.theme.colors.background.strong}
        >
          <CgCreditCard
            color={tinycolor
              .mostReadable(
                shop.theme.colors.background.strong,
                [shop.theme.colors.text],
                {
                  includeFallbackColors: true,
                }
              )
              .toHexString()}
          />
        </Box>
        <VStack w="100%" align="flex-start" spacing="1">
          <Paragraph02>
            <b>Pagás por MercadoPago</b>
          </Paragraph02>
          <Paragraph04>Pagás tu compra online.</Paragraph04>
        </VStack>
      </HStack>
    );

  return (
    <HStack w="100%" px="4" py="2" align="flex-start" spacing="4">
      <Box
        mt="4"
        p="4"
        borderRadius="full"
        backgroundColor={shop.theme.colors.background.strong}
      >
        <CgCreditCard
          color={tinycolor
            .mostReadable(
              shop.theme.colors.background.strong,
              [shop.theme.colors.text],
              {
                includeFallbackColors: true,
              }
            )
            .toHexString()}
        />
      </Box>
      <VStack w="100%" align="flex-start" spacing="1">
        <Paragraph02>
          <b>Pagás directo al comercio</b>
        </Paragraph02>
        <Paragraph04>
          {shop.paymentMethods.custom.messages.es ||
            "Pago directo a acordar con el comercio"}
        </Paragraph04>
      </VStack>
    </HStack>
  );
}
